import { render, staticRenderFns } from "./loki.vue?vue&type=template&id=7ab265db&"
import script from "./loki.vue?vue&type=script&lang=js&"
export * from "./loki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports